import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "tbdc-row tbdc-hover" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_BusyLogo = _resolveComponent("BusyLogo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.matchingLocations")), 1),
    (_ctx.matchingLocations != null && _ctx.matchingLocations.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredMatchingLocations, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "tbdc-grid",
              key: item.id
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  onClick: ($event: any) => {item['zoomTo'] = true; _ctx.setLocation(item)},
                  style: {"cursor":"pointer"},
                  class: "tbdc-overflow"
                }, [
                  _createVNode(_component_v_icon, { class: "mr-3" }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("mdi-map-marker-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(item.name), 1)
                ], 8, _hoisted_4),
                _createElementVNode("div", {
                  onClick: ($event: any) => {item['zoomTo'] = true; _ctx.setLocation(item)},
                  style: {"cursor":"pointer","text-align":"right"},
                  class: "v-tabular"
                }, _toDisplayString(_ctx.$filters.percentage(item.score, _ctx.$i18n.locale, 1)), 9, _hoisted_5),
                _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1))
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.matchingLocations != null && _ctx.matchingLocations.length <= 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("message.noMatchingLocations")), 1))
      : _createCommentVNode("", true),
    (_ctx.matchingLocations == null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_BusyLogo, {
            active: true,
            color: "#b0b0b0",
            size: 40
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}